document.querySelectorAll('.js-video-bg').forEach((frame) => {
  const VIDEO = frame.querySelector('video');

  if (VIDEO.hasAttribute('loop') && VIDEO.hasAttribute('autoplay')) {
    VIDEO
      .play()
      .catch((error) => {
        if (error.name === 'NotAllowedError') {
          VIDEO.style.display = 'none';
        }
      });
  }
});
